export const SET_PUSHED_NOTIFICATION = 'set-pushed-notification';

export const SET_ALL_Notification = 'set-all-notification';

export const SET_RESET_NOTIFICATION = 'set-reset-id';

export const SET_EDIT_NOTIFICATION = 'set-edit-id';
